import axios from 'axios';

export function getCargoTypes() {
    return axios({
        method: 'get',
        url: '/api/v1/cargo/types',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/cargoes/types.js